// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"337cca9a","449":"ddfd690f","563":"ddcf17a2","620":"3360352b","977":"8c979dbc"}[chunkId] + ".chunk.js";
};